export default {
  navMenu: [],
  mnuFncCds: [], // 메뉴 권한
  clkMnuId: '',
  clkMnuNm: '',
};
